/**
 * The item being searched for.
 */
export type Item = {
  [key: string]: string;
};

/**
 * An event which is fired when the textfield's value changes.
 * It passes the value of the textfield.
 */
export type TextChangeEvent = CustomEvent<{ value: string }>;
